import React, { useState } from 'react';
import BaseField from '../BaseField/BaseField';

type BooleanFieldProps = {
  id?: string;
  label?: string;
  displayName?: string;
  showTitle?: boolean;
  value?: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  isSelected?: boolean;
}

const BooleanField = ({ id = 'boolean-field', label = 'Boolean Field', displayName,showTitle = true,value = false, onChange = () => {}, disabled = false, isSelected = false }: BooleanFieldProps) => {
  const [isChecked, setIsChecked] = useState(value);
  const baseId = id || 'boolean-field';

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange(newValue);
  };

  const displayLabel = showTitle && displayName ? displayName : (showTitle ? label : '');

  return (
    <BaseField
      id={baseId}
      label={displayLabel}
      isSelected={isSelected}
      showTitle={showTitle}
    >
      <div id={`${baseId}-toggle-container`} className="tw-flex tw-items-center">
        <label id={`${baseId}-toggle-label`} className="tw-inline-flex tw-items-center tw-cursor-pointer">
          <input
            id={`${baseId}-toggle-input`}
            data-testid={`${baseId}-toggle-input`}
            type="checkbox"
            checked={isChecked}
            onChange={handleChange}
            disabled={disabled}
            className="tw-sr-only tw-peer"
          />
          <div id={`${baseId}-toggle-switch`} className="tw-relative tw-w-11 tw-h-6 tw-bg-gray-200 tw-rounded-full peer tw-peer-focus:ring-4 tw-peer-focus:ring-blue-300 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:tw-bg-blue-600"></div>
          <span id={`${baseId}-toggle-text`} className="tw-ml-3 tw-text-sm tw-font-medium tw-text-gray-700">
            {isChecked ? 'Yes' : 'No'}
          </span>
        </label>
      </div>
    </BaseField>
  );
};

export default BooleanField;